var map = {
	"./en/header.json": 96535,
	"./es/header.json": 19929,
	"./fr/header.json": 24929,
	"./ja/header.json": 23732,
	"./kr/header.json": 66594,
	"./th/header.json": 53597,
	"./tr/header.json": 6651,
	"./vi/header.json": 40865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62549;